import { Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { isFeuilleDeMatchFull } from '../../utils/feuilleMatch.js'
import { EMPTY_PLAYER } from '../../utils/helpers.js'

const RecapTotalMinutesPlayed = ({state, match, onChangeText, onChangeTitle, inHistory}) => {
    const {team, outplayer, timer, comment, title, period} = state

    //const [img] = undefined;

    const actualPeriod =  period ??  match.period
    const {homeHolders, homeSubstitutes, awayHolders, awaySubstitutes, homeTeam, awayTeam} = match
    let allPlayers = isFeuilleDeMatchFull(match) ? [...homeHolders, ...homeSubstitutes, ...awayHolders, ...awaySubstitutes] : [...match.homeTeam.players, ...match.awayTeam.players]
    //let allTeams = isFeuilleDeMatchFull(match) ? [...homeTeam, ...awayTeam] : []
    //let resolvedTeam = allTeams.find(t => t._id === team)
    //[homeTeam, awayTeam].find(t => t._id === team)
    let resolvedPlayer = allPlayers.find(p => p._id === outplayer) ?? EMPTY_PLAYER
    
      // Gestion du text
      useEffect(() => {
        if(!state.text || state.edited){
                console.log(comment + ' TEAM = ' + team);
            const monText = comment + resolvedPlayer && resolvedPlayer.lastname ? ' de ' + resolvedPlayer.firstname + resolvedPlayer.lastname : ''
            
            if(!inHistory)
                onChangeText && onChangeText(monText)
        }

        if(!state.title || state.edited){
            const monTitle = 'MINUTES JOUEES'
            
            if(!inHistory){
                onChangeTitle && onChangeTitle(monTitle)
            }
                
        }
    }, [])

    return (
      <div style={{color : inHistory ? 'black' : 'white'}}>
        {/*<img src={img} width={150}/>*/ console.log(comment + ' TEAM = ' + team)}
        <Typography>{comment} {resolvedPlayer && resolvedPlayer.lastname ? ` de ${resolvedPlayer.firstname} ${resolvedPlayer.lastname}` : ''}</Typography>
      </div>
    )
  }

export default RecapTotalMinutesPlayed